import request from '@/utils/request'
const state = {
    listaProductos: [],
    listaProductosOut: [],
    servicios: []
}

const getters = {
    listaProductosAvailables(state) {
        return state.listaProductos.filter((val) => {
            if (val.id_category != '4' && val.id_category != '5') {
                return val
            }
        })
    },
    listaCortesia(state) {
        return state.listaProductos.filter((val) => {
            if (val.id_category == '4' || val.id_category == '5') {
                return val
            }
        })
    },
    listaProductosOut(state) {
        return state.listaProductosOut.filter((val) => {
            if (val.id_category != '4' && val.id_category != '5') {
                return val
            }
        })
    },
    listaCortesiaOut(state) {
        return state.listaProductos.filter((val) => {
            if (val.id_category == '4' || val.id_category == '5') {
                return val
            }
        })
    }
}

const mutations = {
    UPDATE_LISTA(state, payload) {
        state.listaProductos = payload
    },
    UPDATE_LISTA_OUT(state, payload) {
        state.listaProductosOut = payload
    },
    UPDATE_LISTA_SERVICIOS(state, payload) {
        state.servicios = payload
    }
}

const actions = {
    async getLista({ commit, rootState, state }, payload) {
        const { idSede, idBussines } = rootState.users.user
        /* idBussines :2 , share products */
        //console.log('get lista')
        if (state.listaProductos.length < 1 || payload.online) {
            //console.log('productos_from_server')
            let query = encodeURIComponent(`{"where":{"and":[{"idSede": ${idSede}}]}}`)
            if ([2, 4].includes(idBussines)) {
                query = encodeURIComponent(`{"where":{"and":[{"idBussines": ${idBussines}}]}}`)
            }

            const response = await request({
                url: `/api-loopback/tb_products?filter=${query}`,
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                }
            })
            // //console.log(response.data);
            commit('UPDATE_LISTA', response.data)
        } else {
            //console.log('productos_from_cache')
        }
    },
    async buscarProducto({ dispatch }, { text, idSede }) {
        // Forward to searchProductos
        return await dispatch('searchProductos', { text, idSede })
    },

    /**
     * Plantillas de venta (productos plantilla) de la sede.
     *
     * Es la opción secundaria del cotizador: la búsqueda de productos sigue
     * siendo el camino principal, la plantilla sólo ahorra tipeo cuando varios
     * productos se venden siempre juntos.
     *
     * No oculta errores: si el BFF no responde el llamador debe avisar en vez
     * de mostrar "sin plantillas", que haría pensar que no hay ninguna cargada.
     */
    async getPlantillas({}, { idSede, showInternals = false } = {}) {
        if (!idSede) {
            throw new Error('Falta la sede para consultar las plantillas')
        }

        const { data } = await request({
            url: `/ms/migraciones/v1.0/productos/templates?idSede=${idSede}&showInternals=${showInternals}`,
            method: 'GET',
            timeout: 8000
        })

        return data.data || []
    },

    async searchProductos({ rootState }, { text, idSede, showInternals = false }) {
        // Input validation
        if (!text || text.trim().length < 4) {
            return []
        }
        
        try {
            const { data } = await request({
                url: `/ms/migraciones/v1.0/productos/search?text=${encodeURIComponent(text)}&idSede=${idSede}&showInternals=${showInternals}`,
                method: 'GET',
                timeout: 5000 // 5 second timeout
            })
            
            // Return array of products
            return data.data || []
        } catch (error) {
            console.error('Product search error:', error)
            return []
        }
    },

    async postLista({ rootState }, payload) {
        //console.log('productos ', payload)
        // ////console.log(payload)
        const data = {
            idSede: rootState.users.user.idSede,
            idBussines: rootState.users.user.idBussines,
            ...payload
        }
        // //console.log(data);
        const response = await request({
            url: '/api-loopback/tb_products',
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        // //////console.log(response.data);
        return response.data
    },
    async delLista({}, payload) {
        // ////console.log(payload);
        const response = await request({
            url: `/api-loopback/tb_products/${payload.id}`,

            method: 'DELETE',
            headers: {
                'content-type': 'application/json'
            }
        })
        // //////console.log(response.data);
        return response.data
    },
    async updateProducto({}, payload) {
        // //console.log("update_producto");

        const data = { ...payload }
        // //console.log(data);
        const response = await request({
            url: `/api-loopback/tb_products/${payload.id}`,
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
        // //////console.log(response.data);
        return response.data
    },
    async getListaOut({ commit, rootState }) {
        const { idSede } = rootState.users.user
        /* {"where":{"and":[{"idSede": 4},{"stock":1},{"quantity":{"between":[0,5]}}]}} */

        const response = await request({
            //url: `/api-loopback/tb_products?filter={"where":{"and":[{"idSede": ${idSede}},{"stock":1},{"quantity":{"between":[-100,2]}}]}, "order":"quantity ASC"}`,
            url: `/api-loopback/tb_products?filter={"where":{"and":[{"idSede": ${idSede}}]}}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        //console.log('productos-limit')
        //console.log(response.data)
        commit('UPDATE_LISTA_OUT', response.data)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
